import { Component } from '@angular/core';
import { onEverySecond, LocalTimeZoneClock } from "src/clock";
import { DateTimeFormatter } from "src/angular/components/clock-feed/dateTimeFormatter";
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';


function formatDate(d: Date) : string {
    return DateTimeFormatter.format(d, "YYYY-MM-DD HH:mm:ss");
}

@Component({
    templateUrl: './time-diagnostics-view.component.html',
    selector: 'time-diagnostics-view',
    styleUrls: ['./time-diagnostics-view.component.scss']
}) 
export class TimeDiagnosticsViewComponent{
    constructor(private clock: LocalTimeZoneClock) {
    }
    
    ngOnInit() {
        let onSecondObserver = onEverySecond(this.clock).pipe(share());
        this.localTime$ = onSecondObserver.pipe(
            map(ignoredTimeParameter => formatDate(new Date()))
        )
        this.adjustedTime$ = onSecondObserver.pipe(
            map(formatDate)
        )
    }

    public localTime$ : Observable<string>;

    public adjustedTime$: Observable<string>;
}

